import React from 'react';
import { bool, func, string } from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { login, authenticationInProgress } from '../../ducks/auth.duck';

import { Modal, NamedLink, IconHeart } from '../../components';
import LoginForm from '../../containers/AuthenticationPage/LoginForm/LoginForm';

import css from './LoginModal.module.css';

const LoginModalComponent = props => {
  const {
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    authInProgress,
    loginError,
    submitLogin,
  } = props;

  // Passed along so that signup (and the auth page redirect) returns the user here
  const location = useLocation();

  const handleClose = e => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    onClose();
  };

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={handleClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      containerClassName={css.modalContainer}
    >
      <div className={css.container} onClick={e => e.stopPropagation()}>
        <div className={css.header}>
          <IconHeart className={css.headerIcon} isFilled />
          <h2 className={css.title}>
            <FormattedMessage id="LoginModal.title" />
          </h2>
        </div>

        <div className={css.content}>
          {loginError ? (
            <div className={css.error}>
              <FormattedMessage id="AuthenticationPage.loginFailed" />
            </div>
          ) : null}

          <LoginForm formId={id} onSubmit={submitLogin} inProgress={authInProgress} />

          <p className={css.signupHelper}>
            <FormattedMessage
              id="LoginModal.signupLinkInfo"
              values={{
                signupLink: (
                  <NamedLink
                    name="SignupPage"
                    className={css.signupLink}
                    to={{ state: { from: location } }}
                  >
                    <FormattedMessage id="LoginModal.signupLink" />
                  </NamedLink>
                ),
              }}
            />
          </p>
        </div>
      </div>
    </Modal>
  );
};

LoginModalComponent.defaultProps = {
  loginError: null,
};

LoginModalComponent.propTypes = {
  id: string.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  authInProgress: bool.isRequired,
  loginError: propTypes.error,
  submitLogin: func.isRequired,
};

const mapStateToProps = state => {
  const { loginError } = state.auth;
  return {
    authInProgress: authenticationInProgress(state),
    loginError,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
});

const LoginModal = connect(mapStateToProps, mapDispatchToProps)(LoginModalComponent);

export default LoginModal;
